import { render, staticRenderFns } from "./RecipeStat.vue?vue&type=template&id=dab341ce&scoped=true"
import script from "./RecipeStat.vue?vue&type=script&lang=js"
export * from "./RecipeStat.vue?vue&type=script&lang=js"
import style0 from "./RecipeStat.vue?vue&type=style&index=0&id=dab341ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab341ce",
  null
  
)

export default component.exports